import React, { Component } from "react";
import { objectTypes } from "../../../core/components/buttonpanel/interface/Ibuttons";

interface IGameGeneralComponent {
    data: {}
}
export const gameGeneralComponentPortrait: IGameGeneralComponent = {
    data: {
        "COMPONENTS": [
            {
                child: [
                    {
                        "id": "gameGeneralScrollComponentPortrait",
                        "name": "gameGeneralScrollComponentPortrait",
                        "type": "Container",
                        "x": -150,
                        "y": 0,
                        "visible": true,
                        "scale": 1.2,
                        "filterTypes": [],
                        child: [

                        ]
                    },
                    {
                        "id": "gameGeneralContentPortrait",
                        "name": "gameGeneralContentPortrait",
                        "type": "Container",
                        "x": -350,
                        "y": -200,
                        "visible": true,
                        "filterTypes": [],
                        child: [
                            {
                                "id": "soundEffectContainer",
                                "name": "soundEffectContainer",
                                "type": "Container",
                                "x": 0,
                                "y": 0,
                                "visible": true,
                                child: [
                                    {
                                        "name": "iconsound_effects",
                                        "image": "iconsound_effects.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 80,
                                        "height": 80,
                                        "anchor": [0.5, 0.5],
                                        "x": 587,
                                        "y": 323,
                                    },

                                    {
                                        "id": "icon_sound_text",
                                        "name": "icon_sound_text",
                                        "type": "Text",
                                        "x": 750,
                                        "y": 321,
                                        "width": 500,
                                        "visible": true,
                                        "text": "game-guide_control_heading_sound",
                                        "scaleToFit": true,
                                        "anchor": [0.5, 0.5],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },

                                    {
                                        "id": "soundEffect_disablePortrait",
                                        "name": "musicRadioButtonOffPortrait",
                                        "type": objectTypes.Sprite,
                                        "interactive": true,
                                        "visible": true,
                                        "width": 65,
                                        "height": 31,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                        "text": "",
                                        "buttonMode": true,
                                        "buttonState": {
                                            up: 'setting_radio_btn_disbale.png',
                                            out: 'setting_radio_btn_disbale.png',
                                            down: 'setting_radio_btn_disbale.png',
                                            disable: 'setting_radio_btn_disbale.png',
                                            enable: 'setting_radio_btn_disbale.png',
                                            hover: 'setting_radio_btn_disbale.png'
                                        },
                                        "hitareaVisible": false,
                                        "shapeVisible": false,
                                        "shape": {}
                                    },
                                    {
                                        "name": "musicRadioButtonOnPortrait",
                                        "type": objectTypes.Sprite,
                                        "interactive": true,
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 65,
                                        "height": 31,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                        "buttonMode": true,
                                        "buttonState": {
                                            up: 'setting_radio_btn_enable.png',
                                            out: 'setting_radio_btn_enable.png',
                                            down: 'setting_radio_btn_enable.png',
                                            disable: 'setting_radio_btn_enable.png',
                                            enable: 'setting_radio_btn_enable.png',
                                            hover: 'setting_radio_btn_enable.png'
                                        },
                                    },
                                    {
                                        "name": "soundEffect_text_divider",
                                        "image": "text_divider.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 580,
                                        "height": 1,
                                        "anchor": [0.5, 0.5],
                                        "x": 970,
                                        "y": 370,
                                    },

                                ]
                            },
                            {
                                "id": "bgMusicContainer",
                                "name": "bgMusicContainer",
                                "type": "Container",
                                "x": 0,
                                "y": 0,
                                "visible": true,
                                child: [
                                    {
                                        "name": "iconbgMusic_effects",
                                        "image": "iconbackground_music.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 80,
                                        "height": 80,
                                        "anchor": [0.5, 0.5],
                                        "x": 587,
                                        "y": 323,
                                    },

                                    {
                                        "id": "icon_bgMusic_text",
                                        "name": "icon_bgMusic_text",
                                        "type": "Text",
                                        "x": 687,
                                        "y": 308,
                                        "width": 500,
                                        "visible": true,
                                        "text": "setting_music",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },

                                    {
                                        "name": "bgMusic_disablePortrait",
                                        "type": objectTypes.Sprite,
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 65,
                                        "height": 31,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                        "buttonMode": true,
                                        "buttonState": {
                                            up: 'setting_radio_btn_disbale.png',
                                            out: 'setting_radio_btn_disbale.png',
                                            down: 'setting_radio_btn_disbale.png',
                                            disable: 'setting_radio_btn_disbale.png',
                                            enable: 'setting_radio_btn_disbale.png',
                                            hover: 'setting_radio_btn_disbale.png'
                                        },
                                    },
                                    {
                                        "name": "bgMusic_enablePortrait",
                                        "type": objectTypes.Sprite,
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 65,
                                        "height": 31,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                        "buttonMode": true,
                                        "buttonState": {
                                            up: 'setting_radio_btn_enable.png',
                                            out: 'setting_radio_btn_enable.png',
                                            down: 'setting_radio_btn_enable.png',
                                            disable: 'setting_radio_btn_enable.png',
                                            enable: 'setting_radio_btn_enable.png',
                                            hover: 'setting_radio_btn_enable.png'
                                        },
                                    },
                                    {
                                        "name": "bgMusic_text_divider",
                                        "image": "text_divider.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 580,
                                        "height": 1,
                                        "anchor": [0.5, 0.5],
                                        "x": 970,
                                        "y": 370,
                                    },

                                ]
                            },
                            {
                                "id": "showhelpContainer",
                                "name": "showhelpContainer",
                                "type": "Container",
                                "x": 0,
                                "y": 0,
                                "visible": true,
                                child: [
                                    {
                                        "name": "iconshowhelp_effects",
                                        "image": "iconshow_help_screen.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 80,
                                        "height": 80,
                                        "anchor": [0.5, 0.5],
                                        "x": 587,
                                        "y": 323,
                                    },

                                    {
                                        "id": "icon_showhelp_text",
                                        "name": "icon_showhelp_text",
                                        "type": "Text",
                                        "x": 687,
                                        "y": 308,
                                        "width": 500,
                                        "visible": true,
                                        "text": "showhelpText",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },
                                    {
                                        "name": "introScreenRadioButtonOffPortrait",
                                        "type": objectTypes.Sprite,
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 65,
                                        "height": 31,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                        "buttonMode": true,
                                        "buttonState": {
                                            up: 'setting_radio_btn_disbale.png',
                                            out: 'setting_radio_btn_disbale.png',
                                            down: 'setting_radio_btn_disbale.png',
                                            disable: 'setting_radio_btn_disbale.png',
                                            enable: 'setting_radio_btn_disbale.png',
                                            hover: 'setting_radio_btn_disbale.png'
                                        },

                                    },
                                    {
                                        "name": "introScreenRadioButtonOnPortrait",
                                        "type": objectTypes.Sprite,
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 65,
                                        "height": 31,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                        "buttonMode": true,
                                        "buttonState": {
                                            up: 'setting_radio_btn_enable.png',
                                            out: 'setting_radio_btn_enable.png',
                                            down: 'setting_radio_btn_enable.png',
                                            disable: 'setting_radio_btn_enable.png',
                                            enable: 'setting_radio_btn_enable.png',
                                            hover: 'setting_radio_btn_enable.png'
                                        },
                                    },


                                    {
                                        "name": "showhelp_text_divider",
                                        "image": "text_divider.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 580,
                                        "height": 1,
                                        "anchor": [0.5, 0.5],
                                        "x": 970,
                                        "y": 370,
                                    },

                                ]
                            },
                            {
                                "id": "displayCoinContainer",
                                "name": "displayCoinContainer",
                                "type": "Container",
                                "x": 0,
                                "y": 0,
                                "visible": true,
                                child: [
                                    {
                                        "name": "icondisplayCoin_effects",
                                        "image": "icondisplay_in_coins.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 80,
                                        "height": 80,
                                        "anchor": [0.5, 0.5],
                                        "x": 587,
                                        "y": 323,
                                    },

                                    {
                                        "id": "icon_displayCoin_text",
                                        "name": "icon_displayCoin_text",
                                        "type": "Text",
                                        "x": 687,
                                        "y": 308,
                                        "width": 500,
                                        "visible": true,
                                        "text": "setting_display-in-coins",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },
                                    {
                                        "name": "displayCoin_enablePortrait",
                                        "type": objectTypes.Sprite,
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 65,
                                        "height": 31,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                        "buttonMode": true,
                                        "buttonState": {
                                            up: 'setting_radio_btn_enable.png',
                                            out: 'setting_radio_btn_enable.png',
                                            down: 'setting_radio_btn_enable.png',
                                            disable: 'setting_radio_btn_enable.png',
                                            enable: 'setting_radio_btn_enable.png',
                                            hover: 'setting_radio_btn_enable.png'
                                        },
                                    },
                                    {
                                        "name": "displayCoin_disablePortrait",
                                        "type": objectTypes.Sprite,
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 65,
                                        "height": 31,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                        "buttonMode": true,
                                        "buttonState": {
                                            up: 'setting_radio_btn_disbale.png',
                                            out: 'setting_radio_btn_disbale.png',
                                            down: 'setting_radio_btn_disbale.png',
                                            disable: 'setting_radio_btn_disbale.png',
                                            enable: 'setting_radio_btn_disbale.png',
                                            hover: 'setting_radio_btn_disbale.png'
                                        },
                                    },

                                    {
                                        "name": "displayCoin_text_divider",
                                        "image": "text_divider.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 580,
                                        "height": 1,
                                        "anchor": [0.5, 0.5],
                                        "x": 970,
                                        "y": 370,
                                    },

                                ]
                            },
                            {
                                "id": "quickSpinContainer",
                                "name": "quickSpinContainer",
                                "type": "Container",
                                "x": 0,
                                "y": 0,
                                "visible": true,
                                child: [
                                    {
                                        "name": "iconquickSpin_effects",
                                        "image": "iconquickspin_mode.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 80,
                                        "height": 80,
                                        "anchor": [0.5, 0.5],
                                        "x": 587,
                                        "y": 323,
                                    },

                                    {
                                        "id": "icon_quickSpin_text",
                                        "name": "icon_quickSpin_text",
                                        "type": "Text",
                                        "x": 687,
                                        "y": 308,
                                        "width": 500,
                                        "visible": true,
                                        "text": "setting_quick-spin",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },
                                    {
                                        "name": "turboSpinRadioButtonOnPortrait",
                                        "image": "setting_radio_btn_enable.png",
                                        "type": objectTypes.Sprite,
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 65,
                                        "height": 31,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                        "buttonMode": true,
                                        "buttonState": {
                                            up: 'setting_radio_btn_enable.png',
                                            out: 'setting_radio_btn_enable.png',
                                            down: 'setting_radio_btn_enable.png',
                                            disable: 'setting_radio_btn_enable.png',
                                            enable: 'setting_radio_btn_enable.png',
                                            hover: 'setting_radio_btn_enable.png'
                                        },
                                    },
                                    {
                                        "name": "turboSpinRadioButtonOffPortrait",
                                        "image": "setting_radio_btn_disbale.png",
                                        "type": objectTypes.Sprite,
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 65,
                                        "height": 31,
                                        "anchor": [0.5, 0.5],
                                        "x": 1230,
                                        "y": 321,
                                        "buttonMode": true,
                                        "buttonState": {
                                            up: 'setting_radio_btn_disbale.png',
                                            out: 'setting_radio_btn_disbale.png',
                                            down: 'setting_radio_btn_disbale.png',
                                            disable: 'setting_radio_btn_disbale.png',
                                            enable: 'setting_radio_btn_disbale.png',
                                            hover: 'setting_radio_btn_disbale.png'
                                        },

                                    },

                                    {
                                        "name": "quickSpin_text_divider",
                                        "image": "text_divider.png",
                                        "type": "Image",
                                        "class": "",
                                        "layout": false,
                                        "uimode": "desktop",
                                        "visible": true,
                                        "width": 580,
                                        "height": 1,
                                        "anchor": [0.5, 0.5],
                                        "x": 970,
                                        "y": 370,
                                    },

                                ]
                            },
                            /*   {
                                  "id": "switchControlContainer",
                                  "name": "switchControlContainer",
                                  "type": "Container",
                                  "x": 0,
                                  "y": 0,
                                  "visible": true,
                                  child: [
                                      {
                                          "name": "iconswitchControl_effects",
                                          "image": "iconswitch_controls_side.png",
                                          "type": "Image",
                                          "class": "",
                                          "layout": false,
                                          "uimode": "desktop",
                                          "visible": true,
                                          "width": 80,
                                          "height": 80,
                                          "anchor": [0.5, 0.5],
                                          "x": 587,
                                          "y": 323,
                                      },
  
                                      {
                                          "id": "icon_switchControl_text",
                                          "name": "icon_switchControl_text",
                                          "type": "Text",
                                          "x": 687,
                                          "y": 308,
                                          "width": 500,
                                          "visible": true,
                                          "text": "switchControlText",
                                          "scaleToFit": true,
                                          "anchor": [0, 0],
                                          "textStyle": {
                                              fontFamily: 'Oswald-Regular',
                                              fontSize: 24,
                                              fontStyle: 'normal',
                                              fill: ['#ffffff'],
                                          },
                                      },
                                      {
                                          "name": "switchControl_enablePortrait",
                                          "type": objectTypes.Sprite,
                                          "class": "",
                                          "layout": false,
                                          "uimode": "desktop",
                                          "visible": true,
                                          "width": 65,
                                          "height": 31,
                                          "anchor": [0.5, 0.5],
                                          "x": 1230,
                                          "y": 321,
                                          "buttonMode": true,
                                          "buttonState": {
                                              up: 'setting_radio_btn_enable.png',
                                              out: 'setting_radio_btn_enable.png',
                                              down: 'setting_radio_btn_enable.png',
                                              disable: 'setting_radio_btn_enable.png',
                                              enable: 'setting_radio_btn_enable.png',
                                              hover: 'setting_radio_btn_enable.png'
                                          },
                                      },
                                      {
                                          "name": "switchControl_disablePortrait",
                                          "type": objectTypes.Sprite,
                                          "class": "",
                                          "layout": false,
                                          "uimode": "desktop",
                                          "visible": true,
                                          "width": 65,
                                          "height": 31,
                                          "anchor": [0.5, 0.5],
                                          "x": 1230,
                                          "y": 321,
                                          "buttonMode": true,
                                          "buttonState": {
                                              up: 'setting_radio_btn_disbale.png',
                                              out: 'setting_radio_btn_disbale.png',
                                              down: 'setting_radio_btn_disbale.png',
                                              disable: 'setting_radio_btn_disbale.png',
                                              enable: 'setting_radio_btn_disbale.png',
                                              hover: 'setting_radio_btn_disbale.png'
                                          },
                                      },
  
                                      {
                                          "name": "switchControl_text_divider",
                                          "image": "text_divider.png",
                                          "type": "Image",
                                          "class": "",
                                          "layout": false,
                                          "uimode": "desktop",
                                          "visible": true,
                                          "width": 580,
                                          "height": 1,
                                          "anchor": [0.5, 0.5],
                                          "x": 970,
                                          "y": 370,
                                      },
  
                                  ]
                              }, */
                            /*        {
                                       "id": "pressSbacebarContainer",
                                       "name": "pressSbacebarContainer",
                                       "type": "Container",
                                       "x": 0,
                                       "y": 900,
                                       "visible": true,
                                       child: [
                                           {
                                               "name": "iconpressSbacebar_effects",
                                               "image": "iconpress_spacebar.png",
                                               "type": "Image",
                                               "class": "",
                                               "layout": false,
                                               "uimode": "desktop",
                                               "visible": true,
                                               "width": 80,
                                               "height": 80,
                                               "anchor": [0.5, 0.5],
                                               "x": 587,
                                               "y": 323,
                                           },
       
                                           {
                                               "id": "icon_pressSbacebar_text",
                                               "name": "icon_pressSbacebar_text",
                                               "type": "Text",
                                               "x": 687,
                                               "y": 308,
                                               "width": 500,
                                               "visible": true,
                                               "text": "pressSbacebarText",
                                               "scaleToFit": true,
                                               "anchor": [0, 0],
                                               "textStyle": {
                                                   fontFamily: 'Oswald-Regular',
                                                   fontSize: 24,
                                                   fontStyle: 'normal',
                                                   fill: ['#ffffff'],
                                               },
                                           },
       
                                           {
                                               "name": "spaceBarToSpinRadioButtonOffPortrait",
                                               "image": "setting_radio_btn_disbale.png",
                                               "type": objectTypes.Sprite,
                                               "class": "",
                                               "layout": false,
                                               "uimode": "desktop",
                                               "visible": true,
                                               "width": 65,
                                               "height": 31,
                                               "anchor": [0.5, 0.5],
                                               "x": 1230,
                                               "y": 321,
                                               "buttonMode": true,
                                               "buttonState": {
                                                   up: 'setting_radio_btn_disbale.png',
                                                   out: 'setting_radio_btn_disbale.png',
                                                   down: 'setting_radio_btn_disbale.png',
                                                   disable: 'setting_radio_btn_disbale.png',
                                                   enable: 'setting_radio_btn_disbale.png',
                                                   hover: 'setting_radio_btn_disbale.png'
                                               },
                                           },
                                           {
                                               "name": "spaceBarToSpinRadioButtonOnPortrait",
                                               "image": "setting_radio_btn_enable.png",
                                               "type": objectTypes.Sprite,
                                               "class": "",
                                               "layout": false,
                                               "uimode": "desktop",
                                               "visible": true,
                                               "width": 65,
                                               "height": 31,
                                               "anchor": [0.5, 0.5],
                                               "x": 1230,
                                               "y": 321,
                                               "buttonMode": true,
                                               "buttonState": {
                                                   up: 'setting_radio_btn_enable.png',
                                                   out: 'setting_radio_btn_enable.png',
                                                   down: 'setting_radio_btn_enable.png',
                                                   disable: 'setting_radio_btn_enable.png',
                                                   enable: 'setting_radio_btn_enable.png',
                                                   hover: 'setting_radio_btn_enable.png'
                                               },
                                           },
                                           {
                                               "name": "pressSbacebar_text_divider",
                                               "image": "text_divider.png",
                                               "type": "Image",
                                               "class": "",
                                               "layout": false,
                                               "uimode": "desktop",
                                               "visible": true,
                                               "width": 580,
                                               "height": 1,
                                               "anchor": [0.5, 0.5],
                                               "x": 970,
                                               "y": 370,
                                           },
       
                                       ]
                                   },
        */

                            // {
                            //     "id": "GameAutoplayComponentPortrait",
                            //     "name": "GameAutoplayComponentPortrait",
                            //     "type": "Tag",
                            //     "class": "",
                            //     "parentLayer": "specialAnimationLayer",
                            //     "filterTypes": [],
                            //     child: []
                            // },
                        ]
                    },



                ]
            },

        ],
    }


};

export const GameGeneralComponentPortraitConfigurationContext = React.createContext(
    {}
);